export const initialUnits = [
    { id: 1, building_id: "P001", unit_id: "P001-101", type: "1 BHK", status: "OPEN", details: "Furnished Marina View", location: "Downtown Dubai", rent_availability: "0.000 VACANT", available_from: "Available", active_on: "2026-07-02", category: "ONE-BEDROOM", property_no: "PROP-9921", size: "75", dewa: "DEWA-992812", current_rent: "45000.00", previous_rent: "42000.00" },
    { id: 2, building_id: "P001", unit_id: "P001-503", type: "1 BHK", status: "OPEN", details: "High floor", location: "Downtown Dubai", rent_availability: "0.000 VACANT", available_from: "Available", active_on: "2026-06-15", category: "ONE-BEDROOM", property_no: "PROP-9922", size: "78", dewa: "DEWA-992813", current_rent: "46000.00", previous_rent: "45000.00" },
    { id: 3, building_id: "P001", unit_id: "P001-905", type: "2 BHK", status: "OPEN", details: "Corner Unit", location: "Downtown Dubai", rent_availability: "0.000 VACANT", available_from: "Available", active_on: "2026-05-10", category: "TWO-BEDROOM", property_no: "PROP-9923", size: "115", dewa: "DEWA-992814", current_rent: "75000.00", previous_rent: "72000.00" },
    { id: 4, building_id: "P001", unit_id: "P001-102", type: "2 BHK", status: "OCCUPIED", details: "Garden View", location: "Downtown Dubai", rent_availability: "Rented", available_from: "Rented", active_on: "2026-01-01", category: "TWO-BEDROOM", property_no: "PROP-9924", size: "120", dewa: "DEWA-992815", current_rent: "72000.00", previous_rent: "70000.00" },
    { id: 5, building_id: "P001", unit_id: "P001-103", type: "1 BHK", status: "OPEN", details: "Balcony unit", location: "Downtown Dubai", rent_availability: "0.000 VACANT", available_from: "2026-04-24", active_on: "2026-04-24", category: "ONE-BEDROOM", property_no: "PROP-9925", size: "82", dewa: "DEWA-992816", current_rent: "48000.00", previous_rent: "48000.00" },
    { id: 6, building_id: "P002", unit_id: "P002-104", type: "1 BHK", status: "MAINTENANCE", details: "Plumbing repair", location: "Dubai Marina", rent_availability: "Maintenance", available_from: "Under Maintenance", active_on: "2026-06-20", category: "ONE-BEDROOM", property_no: "PROP-8811", size: "80", dewa: "DEWA-881273", current_rent: "52000.00", previous_rent: "52000.00" },
    { id: 7, building_id: "P002", unit_id: "P002-105", type: "2 BHK", status: "OPEN", details: "Sea View Loft", location: "Dubai Marina", rent_availability: "0.000 VACANT", available_from: "Available", active_on: "2026-03-10", category: "TWO-BEDROOM", property_no: "PROP-8812", size: "135", dewa: "DEWA-881274", current_rent: "95000.00", previous_rent: "90000.00" },
    { id: 8, building_id: "P003", unit_id: "P003-301", type: "Studio", status: "OPEN", details: "Compact layout", location: "Business Bay", rent_availability: "0.000 VACANT", available_from: "Available", active_on: "2026-02-18", category: "STUDIO", property_no: "PROP-7731", size: "45", dewa: "DEWA-773123", current_rent: "38000.00", previous_rent: "35000.00" }
];

export const buildingsMap = {
    "P001": { name: "Al Manarah", type: "Residential" },
    "P002": { name: "Blue2", type: "Commercial" },
    "P003": { name: "Business Tower", type: "Commercial" },
};

export const buildingTypes = ["All", "Residential", "Commercial", "Other"];

export const defaultUnitForm = {
    unit_id: "",
    active_on: "2026-07-02",
    building_id: "P001",
    status: "OPEN",
    details: "",
    category: "ONE-BEDROOM",
    property_no: "",
    location: "",
    size: "",
    type: "1 BHK",
    dewa: "",
    current_rent: "0.00",
    previous_rent: "0.00"
};



// Pending sections :

// Image upload section in unit register:
// Print in unit dashboard 




